import { useState } from 'react'
import CommunityModalSurvey from '../communityModalSurvey'
import { Success } from '../commonSteps/success'
import { PROGRESS_BAR_VALUE_SECOND_POST_EXPERIENCE_STEP, Step } from './secondPostSurvey.constants'
import { SecondPostExperience } from './steps/secondPostExperience'
import { SecondPostImprovement } from './steps/secondPostImprovement'
import { SecondPostMostLiked } from './steps/secondPostMostLiked'

export type SecondPostModalSurveyProps = {
  isOpen: boolean
  onClose: () => void
}

const steps = {
  [Step.SecondPostExperience]: SecondPostExperience,
  [Step.SecondPostMostLiked]: SecondPostMostLiked,
  [Step.SecondPostImprovement]: SecondPostImprovement,
  [Step.Success]: Success
}

const SecondPostSurvey = ({ isOpen, onClose }: SecondPostModalSurveyProps) => {
  const [progressBarValue, setProgressBarValue] = useState<number>(
    PROGRESS_BAR_VALUE_SECOND_POST_EXPERIENCE_STEP
  )
  const [currentStep, setCurrenStep] = useState<Step>(Step.SecondPostExperience)

  const navigateToNextStep = (nextStep: Step) => {
    setCurrenStep(nextStep)
  }

  const handleCloseModal = () => {
    onClose?.()
    setProgressBarValue(0)
    setCurrenStep(Step.SecondPostExperience)
  }

  const CurrentSteps = steps[currentStep]

  return (
    <CommunityModalSurvey
      show={isOpen}
      onClose={handleCloseModal}
      progressBarValue={progressBarValue}
      showHeader={currentStep !== Step.Success}
      showCloseButton={currentStep !== Step.SecondPostExperience}
    >
      <CurrentSteps
        navigateToNextStep={navigateToNextStep}
        setProgressBarValue={setProgressBarValue}
        onCloseModal={handleCloseModal}
      />
    </CommunityModalSurvey>
  )
}

export default SecondPostSurvey
